/**
 * Google OAuth 2.0 — direct flow against the customer's own Google OAuth client.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */

const GOOGLE_AUTH_ENDPOINT = "https://accounts.google.com/o/oauth2/v2/auth";

/** Build and navigate to Google's consent screen. Caller supplies no URLs — they
 * are derived from `window.location.origin` so preview, deploy and custom domains
 * all work without any env-based fallback. */
export function startGoogleSignIn() {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  if (!clientId) {
    // eslint-disable-next-line no-alert
    alert("Google sign-in is not configured. Please contact support.");
    return;
  }

  const redirectUri = window.location.origin + "/auth/callback";
  // CSRF guard — one-time token echoed back by Google via `state`.
  const state = (crypto.randomUUID && crypto.randomUUID()) || Math.random().toString(36).slice(2);
  try {
    sessionStorage.setItem("ar_oauth_state", state);
    sessionStorage.setItem("ar_oauth_redirect_uri", redirectUri);
  } catch { /* storage may be blocked — tolerate */ }

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    access_type: "online",
    include_granted_scopes: "true",
    prompt: "select_account",
    state,
  });
  window.location.href = `${GOOGLE_AUTH_ENDPOINT}?${params.toString()}`;
}
